import http from "@/services/http";

export const tableprice = () => {
  async function list() {
    const {data} = await http.get('/pricetable/list');
    return data;
  }

  async function store(item) {
    const response = await http.post('/pricetable/store', item);
    return response.data;
  }

  async function delet(id) {
    await http.delete('/pricetable/delete/'+id);
    return true;
  }

  async function update(item) {
    const response = await http.post('/pricetable/edit', item);
    return response.data;
  }

  async function getOne(id) {
    const {data} = await http.get('/pricetable/getOne/'+id);
    return data;
  }

  return {list, store, delet, update,getOne};
}
